if (!customElements.get("th-mobile-nav")) {
  class ThMobileNav extends HTMLElement {
    constructor() {
      super();

      this.subDrawerParentSelector = "[data-sub-drawer-parent]";
      this.subDrawerTriggerSelector = "[data-sub-drawer-trigger]";
      this.subDrawerCloserSelector = "[data-sub-drawer-closer]";
    }

    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.querySelectorAll(this.subDrawerTriggerSelector).forEach(
        (trigger) => {
          trigger.addEventListener(
            "click",
            this.handleSubDrawerOpen.bind(this, trigger)
          );
        }
      );
      this.querySelectorAll(this.subDrawerCloserSelector).forEach(
        (closer) => {
          closer.addEventListener(
            "click",
            this.handleSubDrawerClose.bind(this)
          );
        }
      );
    }

    handleSubDrawerOpen(trigger, event) {
      event.preventDefault();
      let subDrawer = this.querySelector(`#${trigger.dataset.subDrawerTrigger}`);
      if (!subDrawer) {return}
      subDrawer.classList.add("th-sub-drawer-open");
    }

    handleSubDrawerClose() {
      this.querySelectorAll(".th-sub-drawer-open").forEach(
        (drawer) => {
          drawer.classList.remove("th-sub-drawer-open")
        }
      )
    }
  }

  customElements.define("th-mobile-nav", ThMobileNav);
}